import { Box, Container, Typography } from '@mui/material'
import React from 'react'

export default function Commerce() {
  return (
    <Container sx={{bgcolor: 'background.default'}}>
      <Box sx={{py: 1}}>
        <Typography variant='h6'>
          特定商取引法に基づく表記
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 3}}>
          サービス名
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          R4MDプレミアム
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 2}}>
          サービス内容
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          「サブスクリプション」のページに記載しています。  
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 2}}>
          サービス提供方法
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          サブスクリプション登録後にインターネット通信により随時提供致します。
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 2}}>
          サービス提供期間
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          サブスクリプション登録から1ヶ月です。
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          なお、キャンセル手続きが取られていなければサブスクリプションは自動更新致します。
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 2}}>
          サービスのキャンセルについて
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          「マイページ」の「サブスクリプションを管理」から登録情報をキャンセルできます。
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 2}}>
          サービス提供後の返金について
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          統計データ閲覧機能を開放するサービスの性質上、お客様都合による返金はお受け致しかねます。
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 2}}>
          販売事業者名（個人事業者）
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          杉本 成輝
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 2}}>
          代表者名
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          杉本 成輝
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 2}}>
          所在地
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          事業者個人の自宅となるため記載を差し控えさせて頂きます。
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          消費者様からの正当な理由ある開示請求にはすみやかにお応えいたします。
        </Typography>

        <Typography variant='subtitle1' sx={{mt: 2}}>
          お問い合わせ
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          サービスのTwitterアカウント（https://twitter.com/RforMD）にダイレクトメッセージをお送りください。
        </Typography>
      </Box>
    </Container>
  )
}